import request from '@/utils/request_yin';
import iconv from 'iconv-lite';

const domain = process.env.yin;
const domains = process.env.yins;
const domaina = process.env.kddh
// const domain = '/yin';

// 报价-利是封
export function req_offer_lishifeng(params){

	let urlParams = '';
	for (let i in params) {
		switch (typeof params[i]) {
			case 'object':
				for (let j in params[i]) {
					params[i][j] = utf8_to_gbk(params[i][j]);
					urlParams += (`&${i}=${params[i][j]}`);
				}
				break;
			case 'string':
				urlParams += ('&' + i + '=' + utf8_to_gbk(params[i]));
				break;
			// case 'hjg': {
			// 	for (let j in params[i]) {
			// 		params[i][j] = utf8_to_gbk(params[i][j]);
			// 		urlParams += ('&hjg=' + params[i][j]);
			// 	}
			// 	break;
			// }
			// case 'tjx': {
			// 	for (let j in params[i]) {
			// 		params[i][j] = utf8_to_gbk(params[i][j]);
			// 		urlParams += ('&tjx=' + params[i][j]);
			// 	}
			// 	break;
			// }
			// case 'tjy': {
			// 	for (let j in params[i]) {
			// 		params[i][j] = utf8_to_gbk(params[i][j]);
			// 		urlParams += ('&tjy=' + params[i][j]);
			// 	}
			// 	break;
			// }
			// case 'tangCl': {
			// 	for (let j in params[i]) {
			// 		params[i][j] = utf8_to_gbk(params[i][j]);
			// 		urlParams += ('&tangCl=' + params[i][j]);
			// 	}
			// 	break;
			// }
			// case 'TJTB': {
			// 	for (let j in params[i]) {
			// 		params[i][j] = utf8_to_gbk(params[i][j]);
			// 		urlParams += ('&TJTB=' + params[i][j]);
			// 	}
			// 	break;
			// }
			// case 'jban': {
			// 	for (let j in params[i]) {
			// 		params[i][j] = utf8_to_gbk(params[i][j]);
			// 		urlParams += ('&jban=' + params[i][j]);
			// 	}
			// 	break;
			// }
			// case 'chichunstr': {
			// 	urlParams += ('&' + i + '=' + utf8_to_gbk(params[i]));
			// 	break;
			// }
			// case 'xfys': {
			// 	urlParams += ('&' + i + '=' + utf8_to_gbk(params[i]));
			// 	break;
			// }
			// case 'zeye': {
			// 	urlParams += ('&' + i + '=' + utf8_to_gbk(params[i]));
			// 	break;
			// }
			// case 'bmcl': {
			// 	urlParams += ('&' + i + '=' + utf8_to_gbk(params[i]));
			// 	break;
			// }
			// case 'yhlx': {
			// 	urlParams += ('&' + i + '=' + utf8_to_gbk(params[i]));
			// 	break;
			// }
			// case 'tj': {
			// 	urlParams += ('&' + i + '=' + utf8_to_gbk(params[i]));
			// 	break;
			// }
			// case 'ty': {
			// 	urlParams += ('&' + i + '=' + utf8_to_gbk(params[i]));
			// 	break;
			// }
			default: {
				urlParams += ('&' + i + '=' + params[i]);
			}
		}
	}

	let url = domain + '/api/ajax_bj.asp';
	url = url + '?' + urlParams.substring(1);
	const data = {
		method:'GET',
		data:{}
	}
	return request(url, data);
}

// 标准报价
export function req_offer_heban(params){

	const caihangapi = params['api'];
	delete params['api'];

	let urlParams = '';
	let hjg='';
	for (let i in params) {

		switch (i) {
			case 'hjg': {

				for (let j in params[i]) {
					if (hjg !== '') {
						hjg += ',';
					}
					hjg += params[i][j];
					
				}
				break;
			}
			default: {
				urlParams += ('&' + i + '=' + params[i]);
			}
		}
	}
	urlParams += ('&hjg=' + hjg);
	
	let url = domains + '/caihang/' + caihangapi;
	url = url + '?' + urlParams.substring(1);
	const data = {
		method:'GET',
		data:{}
	}
	return request(url, data);
}

// 批量上传报价
export function req_offer_batch(filename){
	let url = domains + '/caihang/GetPriceByFile';
	url = url + '?filename=' + filename;
	const data = {
		method:'GET',
		data:{}
	}
	return request(url, data);
}

// 抓取远程Bjlog
export function req_remoteBjlogParams(uid, bid){
	let url = domain + '/api/ajax_logs.asp';
	url = url + '?' + 'lid=' + bid + '&lpid=2634332925' + '&lkey=3816120594047845' + '&uid=' + uid;
	const data = {
		method:'GET',
		data:{
		}
	}
	return request(url, data);
}
// 根据快递单号获取快递信息
export function req_kuaididanhao(com,nu){
	let url = domaina + '/chaxun';
	url = url + '?' + 'com=' + com + '&nu=' + nu;
	const data = {
		method: 'get',
		data:{
		}
	}
   return request(url,data)
}
// 报价-标准信封类
export function req_offer_xinfeng(params){

	let urlParams = '';
	for (let i in params) {

		switch (i) {
			case 'hjg': {
				for (let j in params[i]) {
					params[i][j] = utf8_to_gbk(params[i][j]);
					urlParams += ('&hjg=' + params[i][j]);
				}
				break;
			}
			default: {
				urlParams += ('&' + i + '=' + params[i]);
			}
		}
	}

	let url = domain + '/api/37.asp';
	url = url + '?' + urlParams;
	const data = {
		method:'GET',
		data:{}
	}
	return request(url, data);
}

// 报价-不干胶
export function req_offer_buganjiao(params){

	let urlParams = '';
	for (let i in params) {

		switch (i) {
			case 'hjg': {
				for (let j in params[i]) {
					params[i][j] = utf8_to_gbk(params[i][j]);
					urlParams += ('&hjg=' + params[i][j]);
				}
				break;
			}
			default: {
				urlParams += ('&' + i + '=' + params[i]);
			}
		}
	}

	let url = domain + '/api/16.asp';
	url = url + '?' + urlParams;
	const data = {
		method:'GET',
		data:{}
	}
	return request(url, data);
}

function utf8_to_gbk(string) {
	if (!string) return;

	const reg1 = /[0-9a-z]/i;
	const reg2 = ['(', ')', ':'];

	let result = '';
    
	for (let i in string) {
		if (reg1.test(string[i])) {
			result += string[i];
			continue;
		} else if (reg2.indexOf(string[i]) !== -1) {
			result += string[i];
			continue;
		}

		const str_arr = iconv.encode(string[i], 'GBK');
		for (let i = 0; i < str_arr.length; i+=1) {
			result += ('%' + str_arr.slice(i, i+1)[0].toString(16));
		}
		result = result.toUpperCase();
	}
	return result;
}



// WEBPACK FOOTER //
// ./src/services/product.js